<template>
  <modal
    name="add-inventory-modal"
    width="600"
    height="auto"
    :adaptive="true"
    :scrollable="true"
  >
    <div class="p-6">
      <h2 class="text-xl font-bold mb-4">Yeni Envanter Ekle</h2>

      <form @submit.prevent="save">
        <div class="grid grid-cols-1 gap-4">

          <!-- Ürün Adı -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Ürün Adı <span class="text-red-500">*</span>
            </label>
            <input
              v-model="form.name"
              type="text"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="Örn: Pompa XYZ-123"
            />
          </div>

          <!-- Kategori -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Kategori <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.category"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seçiniz</option>
              <option value="POMPA&HORTUM&DUSURUCU">Pompa & Hortum & Düşürücü</option>
              <option value="GUVENLIK">Güvenlik Ekipmanı</option>
              <option value="YEDEK_PARCA">Yedek Parça</option>
              <option value="DIGER">Diğer</option>
            </select>
          </div>

          <!-- Seri Numarası -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Seri Numarası
            </label>
            <input
              v-model="form.serial_number"
              type="text"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="Opsiyonel"
            />
          </div>

          <!-- Açıklama -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Açıklama
            </label>
            <textarea
              v-model="form.description"
              rows="3"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="Ürün hakkında detaylı bilgi"
            ></textarea>
          </div>

        </div>

        <!-- Butonlar -->
        <div class="flex justify-end space-x-3 mt-6">
          <button
            type="button"
            @click="$modal.hide('add-inventory-modal')"
            class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
          >
            İptal
          </button>
          <button
            type="submit"
            :disabled="loading"
            class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-blue-400"
          >
            <span v-if="loading">Kaydediliyor...</span>
            <span v-else>Kaydet</span>
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import axios from 'axios';
import { inventory } from '../../../../networking/urlmanager';

export default {
  name: 'AddInventoryModal',
  data() {
    return {
      loading: false,
      form: {
        name: '',
        category: '',
        serial_number: '',
        quantity: 1,
        unit: 'ADET',
        description: ''
      }
    };
  },
  methods: {
    async save() {
      if (!this.form.name || !this.form.category) {
        this.$toast.error('Lütfen zorunlu alanları doldurun');
        return;
      }

      this.loading = true;
      try {
        const response = await axios.post(inventory.add, this.form, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          }
        });

        if (response.data.code === 200) {
          this.$toast.success('Envanter başarıyla eklendi');
          this.resetForm();
          this.$modal.hide('add-inventory-modal');
          this.$emit('refresh');
        }
      } catch (error) {
        console.error('Error adding inventory:', error);
        this.$toast.error(error.response?.data?.message || 'Envanter eklenirken hata oluştu');
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form = {
        name: '',
        category: '',
        serial_number: '',
        quantity: 1,
        unit: 'ADET',
        description: ''
      };
    }
  }
};
</script>